module.exports = __webpack_public_path__ + "69d0cafa5b19f3613470a434028aef1b.svg";